import React, { useEffect, useState } from 'react';
import { Obrigado } from '../pages/obrigado/obrigado';
import { useLocation } from 'react-router-dom';
import { Sell } from '../../common/types/venda';

export const ObrigadoTemplate = () => {
  const location = useLocation();
  const [venda, setVenda] = useState<Sell>();
  useEffect(() => {
    if (!location?.state) {
      window.location.href = 'https://vendepay.com.br';
    } else {
      setVenda(location?.state);
    }
  }, [location.state]);
  return <Obrigado venda={venda!} />;
};
